﻿import './GetService.scss';

// Components
import '../../Components/Location/Location.scss';
import '../../Components/Location/LocationMap/LocationMap';
import '../../Shared/Coupon/Coupon.scss';

import '../../Components/Services/Services.scss';
import '../../Components/HighLight/HighLight.scss';


// WEBPACK FOOTER //
// ./Src/Services/GetService/GetService.js